import { useEffect } from 'react';

// Swap the PWA manifest + touch icon so the Field Staff routes install with the staff icon
// and every other route keeps the Residents/Tenants icon.
const APPS = {
  staff: { manifest: '/manifest-staff.json', icon: '/staff-icon-180.png', favicon: '/staff-icon-32.png', title: 'NECS Staff' },
  resident: { manifest: '/manifest.json', icon: '/resident-icon-180.png', favicon: '/resident-icon-32.png', title: 'NECS Resident' },
};

export function applyAppIcons(kind) {
  const app = APPS[kind] || APPS.resident;
  const set = (selector, attr, value) => document.querySelectorAll(selector).forEach((el) => el.setAttribute(attr, value));
  set('link[rel="manifest"]', 'href', app.manifest);
  set('link[rel="apple-touch-icon"]', 'href', app.icon);
  set('link[rel="icon"]', 'href', app.favicon);
  set('meta[name="apple-mobile-web-app-title"]', 'content', app.title);
  set('meta[name="application-name"]', 'content', app.title);
  document.querySelectorAll('link[rel="apple-touch-startup-image"]').forEach((el) => el.setAttribute('href', el.getAttribute('href').replace(/\/splash\/(staff|resident)-/, `/splash/${kind === 'staff' ? 'staff' : 'resident'}-`)));
}

export function useAppIcons(kind) {
  useEffect(() => { applyAppIcons(kind); return () => applyAppIcons('resident'); }, [kind]);
}
